import { Grid } from '@solinkcorp/solink-components';
import React from 'react';
import useLocale from 'src/hooks/useLocale';
import { Detail } from '../../Detail';
import { Map } from '../../Map';
import { type Device } from '../../types/device.types';
import { type Event } from '../../types/event.types';
import './ShareDetails.sass';

interface ShareDetailsProps {
  event?: Event | null;
  device?: Device | null;
  locationName?: string;
  dataReady?: boolean;
}

// Component
const ShareDetails: React.FC<ShareDetailsProps> = ({ event, device, locationName, dataReady }) => {
  const locale = useLocale();
  if (!event || !device || !locationName) return <div data-testid="empty-div" />;
  return (
    <div className="share-details">
      <Grid
        gridTemplateColumns="1fr 1fr"
        gridTemplateRows="none"
        alignItems="start"
        justifyItems="stretch"
        className="share-details-grid"
      >
        <Detail type="location" value={locationName} label={locale.spa.location} />
        <Map location={device} />
        {event.details.description && (
          <Detail
            type="description"
            value={event.details.description}
            label={locale.spa.description}
            className="description"
          />
        )}
        {dataReady && event.type === 'transaction' && (
          <div className="receipt">
            <label>{locale.spa.receipt}</label>
            <pre data-testid="receipt">{event.details.receipt}</pre>
          </div>
        )}
      </Grid>
    </div>
  );
};

export default ShareDetails;
